import React from 'react'
import ReactDOM from 'react-dom'
import MoreVertIcon from '@material-ui/icons/MoreVert';

import './style.scss'

import MenuNub from './nub'
import MenuItem from './item'
import MenuSpacer from './spacer'
import MenuLoader from './loader'
import MenuContent from './content'
import { getMenuPosition, getNubPosition, getBoundingClientRect } from './utils'

import Portal from '../../styled-base/portal'
import MUIIcon from '../../styled-base/mui-icon'
import { KeyDownEvent, eventKeyConstants } from '../../utils/eventKey'

export const InternallyManagedMenu = Symbol('InternallyManagedMenu')

const noop = () => {}

const getInitialTargetRect = () => ({
  x: 0,
  y: 0,
  width: 0,
  height: 0
})

export default class VeryNiceMenu extends React.PureComponent {
  static defaultProps = {
    // External Management
    isOpen: InternallyManagedMenu,
    // Target CSS
    targetClassName: null,
    // Menu CSS
    portalClassName: null,
    // Default Target
    kebabColor: 'white',
    kebabSize: 18,
    // Target
    showTarget: true,
    minTargetWidth: 18,
    includeTargetAsInside: true,
    requireChildren: false,
    // Positioning
    yOffset: 2,
    xOffset: 2,
    alignLeft: false,
    alignEdge: false,
    // Nub
    nubSize: 8,
    nubRatio: 2,
    // Width
    fixedWidth: 200,
    defaultWidth: 0,
    minWidth: 0,
    // Height
    maxHeight: Infinity,
    // Positioning
    isTop: false,
    isBottom: false,
    // Activation type
    isToolTip: false,
    // Exit Type
    closeOnClick: true,
    closeOnEsc: false,
    // Actions
    onOpen: noop,
    onClose: noop,
    onClickOutside: noop,
    onEscPress: noop
  }

  constructor (props) {
    super(props)
    
    this.state = {
      isOpen: false,
      targetRect: getInitialTargetRect()
    }
  }

  onClose = () => this.setState({
    isOpen: false,
    targetRect: getInitialTargetRect()
  }, () => {
    this.props.onClose()
  }) 

  handleShowPopup(e) {
    e.stopPropagation();
    this.onOpen(e)
  }

  onOpen = (e) => {
      e.preventDefault()
      e.stopPropagation()
  
      // Save the rect of the target that triggered the opene event
      const target = this.TargetElement && this.TargetElement.firstChild
  
      const rect = getBoundingClientRect(target || e.target)
      this.setState({
        isOpen: true,
        targetRect: {
          // Normalize AI.
          width: rect.width,
          height: rect.height,
          x: (rect.x || rect.left),
          y: (rect.y || rect.top),
        }
      }, () => {
        this.props.onOpen(e)
      })
  
      setTimeout(() => {
        const elem = document.getElementById('menuId')
        let childItems = elem && elem.children
        childItems && childItems[0] && childItems[0].focus()
      },0)    
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.clickOutside);
    document.addEventListener('keydown', this.clickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.clickOutside);
    document.removeEventListener('keydown', this.clickOutside);
  }

  clickOutside = (e) => {
    if (!this.portalRef) {
      return this.onClose()
    }

    // If we include the target as internal then do not close when it is clicked.
    // This prevents the menu from closing an reopening.
    if (this.props.includeTargetAsInside && this.TargetElement.contains(e.target)) {
      return
    }

    // If we clicked inside, then do nothing.
    // The size me container doesn't forward the ref to the dom element :(
    const domEl = ReactDOM.findDOMNode(this.portalRef)
    if (domEl && domEl.contains && domEl.contains(e.target)) {
      if ($(e.target).hasClass('dropdown-menu-item') && this.state.isOpen && (e.key === eventKeyConstants.ENTER || e.key === eventKeyConstants.SPACE)) {
        return this.onClose()
      }
      return
    }

    this.onClose()
  }

  clickInside = (e) => {
    e.preventDefault()
    e.stopPropagation()

    if (this.props.closeOnClick) {
      this.onClose()
    }
  }

  render () {
    // Use provided target or create one
    const target = this.props.target || <MUIIcon
      component={MoreVertIcon}
      color={this.props.kebabColor}
      disabled={this.props.disabled}
      style={{ fontSize: this.props.kebabSize }}
    />

    // Create target wrapper class name
    const targetClassName = [
      'menu-target',
      this.props.targetClassName
    ].filter(name => name)
    .join(' ')

    // Attach style to content
    const _style = {}
    if (this.props.maxHeight && isFinite(this.props.maxHeight)) {
      _style.maxHeight = this.props.maxHeight
      _style.overflowY = 'auto'
    }

    // Calculate position
    const menuPosition = getMenuPosition({
      alignEdge: this.props.alignEdge,
      isTop: this.props.isTop,
      isBottom: this.props.isBottom,
      yOffset: this.props.yOffset,
      xOffset: this.props.xOffset,
      nubSize: this.props.nubSize,
      rect: this.state.targetRect,
    })
    const nubPosition = getNubPosition({
      rect: this.state.targetRect,
      isTop: this.props.isTop,
      isBottom: this.props.isBottom,
    })

    // If the consumer sets the isOpen prop, we ignore internal state management.
    const showPortal = this.props.isOpen === InternallyManagedMenu
      ? this.state.isOpen
      : !!this.props.isOpen

    // If the menu will have no content, we can chose not to show anything.
    const hasChildren = this.props.requireChildren
     ? React
       .Children
       .toArray(this.props.children)
       .filter(child => child !== null)
       .length > 0
     : true

    const headerTitleStyles = {
      minWidth: this.props.minTargetWidth,
    };

    return (
      <>
        {this.props.showTarget 
          ? <div
              className={targetClassName}
              ref={node => this.TargetElement = node}
              style={headerTitleStyles}
              onClick={!this.props.isToolTip ? this.onOpen : undefined}
              onMouseEnter={this.props.isToolTip ? this.onOpen : undefined}
              onMouseLeave={this.props.isToolTip ? this.onClose : undefined} 
              onKeyDown = {(e) => KeyDownEvent(e, () => this.handleShowPopup(e))}
            >
              { target }
            </div>
          : <div
              ref={node => this.TargetElement = node}
              style={headerTitleStyles}
            />
        }
        {showPortal && hasChildren && <Portal
          wrapperClassName={this.props.portalClassName}
          position={menuPosition}
          centerY={false}
          centerX={false}
        >
          {!this.props?.isUserReadOnly && (
            <section>
              <MenuContent
                ref={(node) => this.portalRef = node}
                fixedWidth={this.props.fixedWidth}
                minWidth={this.props.minWidth}
                disabled={this.props.disabled}
                onClick={this.clickInside}
                onClose={this.onClose}
                style={_style}
                closeOnEsc={this.props.closeOnEsc}
                onEscPress={this.props.onEscPress}
              >
                { this.props.children }
              </MenuContent>
              {this.props.nubSize > 0 && <MenuNub
                nubSize={this.props.nubSize}
                nubRatio={this.props.nubRatio}
                position={nubPosition}
              />}
            </section>
          )}
        </Portal>}
      </>
    )
  }
}

VeryNiceMenu.Item = MenuItem
VeryNiceMenu.Spacer = MenuSpacer
VeryNiceMenu.Loader = MenuLoader